import type {
  CheckInCustomizationContext,
  CheckInSurveyPlugin,
  SurveyJsonPage,
  SurveyJsonPayload,
} from '../types';
import { InjectionCountPage } from './InjectionCountPage';
import {
  INJECTION_ANCHOR_QUESTION,
  INJECTION_COUNT_QUESTION,
  INJECTION_PAGE_NAME,
  INJECTION_VISIBLE_IF,
} from './injectionCount.config';

const buildInjectionPage = (): SurveyJsonPage => ({
  name: INJECTION_PAGE_NAME,
  visibleIf: INJECTION_VISIBLE_IF,
  elements: [
    {
      type: 'text',
      name: INJECTION_COUNT_QUESTION,
      inputType: 'number',
      isRequired: true,
      title: ' ',
    },
  ],
});

const augment = (
  payload: SurveyJsonPayload,
  _context: CheckInCustomizationContext,
): SurveyJsonPayload => {
  const pages = Array.isArray(payload.pages) ? [...payload.pages] : [];
  const anchorIndex = pages.findIndex((page) =>
    page.elements?.some((el) => el.name === INJECTION_ANCHOR_QUESTION),
  );
  const insertAt = anchorIndex >= 0 ? anchorIndex + 1 : pages.length;
  pages.splice(insertAt, 0, buildInjectionPage());
  return { ...payload, pages };
};

export const injectionCountPlugin: CheckInSurveyPlugin = {
  id: 'injectionCount',
  augment,
  pages: {
    [INJECTION_PAGE_NAME]: InjectionCountPage,
  },
};
